// Based on : https://developers.google.com/maps/documentation/javascript/symbols

export default {
    path: "M11.711-11.696L11.711-11.696C9.112-8.511,1.104-1.026,0,0c-1.104-1.027-9.113-8.512-11.711-11.696C-13.833-14.297-15-17.567-15-20.902c0-8.107,6.714-14.732,15-14.732s15,6.625,15,14.732 C15-17.566,13.832-14.296,11.711-11.696z",
    fillColor: "#FECB00",
    fillOpacity: 1,
    scale: 1,
    strokeColor: "#FFF1C3",
    strokeWeight: 2
};
